var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.991943,
    width: 40.5161,
    height: 40.5161,
    rx: 20.258,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4505 20.7502C29.4505 25.8276 25.3345 29.9437 20.257 29.9437C19.0341 29.9437 17.867 29.705 16.7997 29.2715C16.5955 29.1885 16.4933 29.1471 16.4108 29.1286C16.33 29.1105 16.2702 29.1038 16.1875 29.1038C16.1029 29.1038 16.0107 29.1192 15.8264 29.1499L12.192 29.7556C11.8114 29.8191 11.6211 29.8508 11.4835 29.7918C11.3631 29.7401 11.2671 29.6441 11.2154 29.5237C11.1564 29.3861 11.1881 29.1958 11.2516 28.8152L11.8573 25.1808C11.888 24.9965 11.9034 24.9043 11.9034 24.8197C11.9034 24.737 11.8967 24.6772 11.8786 24.5964C11.8601 24.5139 11.8186 24.4117 11.7357 24.2075C11.3022 23.1402 11.0635 21.9731 11.0635 20.7502C11.0635 15.6727 15.1796 11.5566 20.257 11.5566C25.3345 11.5566 29.4505 15.6727 29.4505 20.7502Z",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7673 23.4143L24.1153 18.0711",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7576 23.3789L15.8913 20.4668",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuiz);
export default __webpack_public_path__ + "static/media/icon-quiz.29119a9c814571f6de28ea79cd4722e9dd05b836148f02e93040408b997184cb.svg";
export { ForwardRef as ReactComponent };